import { cn } from '../../lib/cn'
import { Badge, type BadgeProps } from './Badge'

const statusMap: Record<string, { label: string; variant: BadgeProps['variant'] }> = {
  connected: { label: 'Connected', variant: 'success' },
  healthy: { label: 'Healthy', variant: 'success' },
  online: { label: 'Online', variant: 'success' },
  success: { label: 'Success', variant: 'success' },
  available: { label: 'Available', variant: 'success' },
  warning: { label: 'Warning', variant: 'warning' },
  degraded: { label: 'Degraded', variant: 'warning' },
  updating: { label: 'Updating', variant: 'warning' },
  offline: { label: 'Offline', variant: 'danger' },
  error: { label: 'Error', variant: 'danger' },
  failed: { label: 'Failed', variant: 'danger' },
  disabled: { label: 'Disabled', variant: 'default' },
  unknown: { label: 'Unknown', variant: 'default' },
}

export function StatusBadge({
  status,
  className,
}: {
  status: string
  className?: string
}) {
  const key = status.toLowerCase()
  const mapped = statusMap[key] ?? {
    label: status,
    variant: 'default' as const,
  }
  return (
    <Badge variant={mapped.variant} className={cn(className)}>
      {mapped.label}
    </Badge>
  )
}
